import { gql } from 'apollo-boost';

export const newFunderRating = gql`
  mutation newFunderRating(
      $value: String!,
      $reportId: Int!,
      $funderRatingCategoryId: Int!
  ) {
    newFunderRating(
        value: $value,
        reportId: $reportId,
        funderRatingCategoryId: $funderRatingCategoryId
  ) {
      success
    }
  }
`;
